const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "";
  const ms = Date.now() - Date.parse(iso);
  if (Number.isNaN(ms) || ms < 0) return "";
  if (ms < MINUTE_MS) return "just now";
  const m = Math.floor(ms / MINUTE_MS);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(ms / HOUR_MS);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(ms / DAY_MS);
  if (d < 7) return `${d}d ago`;
  if (d < 30) return `${Math.floor(d / 7)}w ago`;
  if (d < 365) return `${Math.floor(d / 30)}mo ago`;
  return `${Math.floor(d / 365)}y ago`;
}

export type TimeBucket = "today" | "yesterday" | "this_week" | "earlier";

export function bucketOf(iso: string | null | undefined): TimeBucket {
  if (!iso) return "earlier";
  const now = new Date();
  const t = new Date(iso);
  const sameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
  if (sameDay(now, t)) return "today";
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(yesterday, t)) return "yesterday";
  const diffDays = Math.floor((now.getTime() - t.getTime()) / DAY_MS);
  if (diffDays >= 0 && diffDays < 7) return "this_week";
  return "earlier";
}

export const BUCKET_LABELS: Record<TimeBucket, string> = {
  today: "Today",
  yesterday: "Yesterday",
  this_week: "This week",
  earlier: "Earlier",
};
